import { useSelector } from 'react-redux';
import React from 'react';

import { PosPlugin } from 'plugins/plugin';

import { getExchangeState } from '../rdx';

const UIQuantityActionsContainer: PosPlugin['UIQuantityActionsContainer'] = ({
  children,
}) => {
  const exchangeState = useSelector(getExchangeState);
  return <>{exchangeState.exchangeStep > 0 ? <></> : children}</>;
};

export default UIQuantityActionsContainer;
